module.exports = __webpack_public_path__ + "img/Physician - White - Selected.eeb9ece4.png";